import * as React from 'react'

import Paper from '@mui/material/Paper'

import {
  OpportunitySection,
  FollowUpInformationSection,
  TargetPestSection,
  AssignmentSection,
  MarketingAttributionSection,
  OpportunityCustomFields,
} from '../FormSections'
import { useScrollToFieldError } from '@user/components/Formik/ScrollToFieldError/useScrollToFieldError'

type Props = {
  branchId: string
  hideOptional: boolean
  onClosedWonChange: (isClosedWon: boolean, isClosedLost: boolean) => void
}

export function MainForm(props: Props) {
  const { branchId, hideOptional, onClosedWonChange } = props

  useScrollToFieldError()

  return (
    <Paper
      sx={{
        px: 3,
        pt: 3,
        display: 'flex',
        flexDirection: 'column',
        mb: 2,
      }}
      variant="outlined"
    >
      <OpportunitySection />
      <FollowUpInformationSection hideOptional={hideOptional} />
      <TargetPestSection hideOptional={hideOptional} />
      <AssignmentSection
        branchId={branchId}
        onClosedWonChange={onClosedWonChange}
      />
      <MarketingAttributionSection hideOptional={hideOptional} />
      <OpportunityCustomFields hideOptional={hideOptional} />
    </Paper>
  )
}
